export function buildMitigatedRules(items) {
  const arr = Array.isArray(items) ? items : [];
  const rules = arr
    .map((v) => (typeof v?.rule === "string" ? v.rule.trim() : ""))
    .filter(Boolean);

  return [...new Set(rules)].map((rule) => ({ rule }));
}

